module.exports = __webpack_public_path__ + "img/comprehensiveBanner3.c07e359c.png";